import { useRef } from "react";
import { useWebSocket } from "../context/WebSocketContext";
import ChatBody from "./ChatBody";
import ChatFooter from "./ChatFooter";
import ChatHeader from "./ChatHeader";
import { Container, LoaderWrapper, Spinner } from "./styles/ChatStyles";

const ChatContainer = () => {
  const { messages, setMessages, socket, chatEnded } = useWebSocket();
  const exportRef = useRef();

  const isLoading = messages.length === 0;
  const wasDisconnected = messages.some((m) => m.controlType === "DISCONNECT");
  const isSocketOpen = socket?.readyState === WebSocket.OPEN;
  const isDisabled = chatEnded || !isSocketOpen || wasDisconnected;

  return (
    <Container ref={exportRef}>
      <ChatHeader />

      {isLoading ? (
        <LoaderWrapper>
          <Spinner />
          <p>Conectando...</p>
        </LoaderWrapper>
      ) : (
        <>
          <ChatBody messages={messages} exportRef={exportRef} />

          {!isDisabled && (
            <ChatFooter
              messages={messages}
              setMessages={setMessages}
              exportRef={exportRef}
            />
          )}
        </>
      )}
    </Container>
  );
};

export default ChatContainer;
